export default "__VITE_ASSET__3b173b6b__"